<form [formGroup]="model" (ngSubmit)="aplicarFiltros()">
  <div class="row search-area">
    <div class="col-12 col-lg-3 col-xl-4 search-field">
      <mat-form-field appearance="outline">
        <mat-label>Pesquisar</mat-label>
        <input matInput type="text" formControlName="pesquisa"
          placeholder="Pesquise por documento, observação ou operação" />
        <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="col-12 col-lg-9 col-xl-8 filter-container">
      <div class="local-field">
        <mat-form-field appearance="outline">
          <mat-label>Localização</mat-label>
          <mat-select formControlName="idLocalizacaoEstoque" (selectionChange)="aplicarFiltros()">
            <mat-option [value]="null">Todos</mat-option>
            @for (l of listaLocalizacaoEstoque; track l.idLocalizacaoEstoque) {
            <mat-option [value]="l.idLocalizacaoEstoque">{{ l.nome }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <button #periodoMenuTrigger="matMenuTrigger" mat-stroked-button type="button" class="btn-periodo"
        [matMenuTriggerFor]="periodoMenu" (menuOpened)="prepararPeriodoIntervalo()"
        [class.btn-periodo--ativo]="periodoSelecionado !== PeriodoEnum.SemFiltro">
        {{ periodoLabel }}
        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu" (closed)="onPeriodoMenuClosed()">
        <div class="periodo-menu-content">
          <div>
            <button type="button" class="periodo-menu-item"
              (click)="selecionarPeriodo(PeriodoEnum.SemFiltro); aplicarPeriodo()"
              [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.SemFiltro">
              <span>sem filtro</span>
              @if (periodoSelecionado === PeriodoEnum.SemFiltro) {
              <mat-icon>check</mat-icon>
              }
            </button>
            <button type="button" class="periodo-menu-item"
              (click)="selecionarPeriodo(PeriodoEnum.Ultimos30Dias); aplicarPeriodo()"
              [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.Ultimos30Dias">
              <span>últimos 30 dias</span>
              @if (periodoSelecionado === PeriodoEnum.Ultimos30Dias) {
              <mat-icon>check</mat-icon>
              }
            </button>
            <button type="button" class="periodo-menu-item"
              (click)="selecionarPeriodo(PeriodoEnum.DoMes); aplicarPeriodo()"
              [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.DoMes">
              <span>do mês</span>
              @if (periodoSelecionado === PeriodoEnum.DoMes) {
              <mat-icon>check</mat-icon>
              }
            </button>
            <button type="button" class="periodo-menu-item"
              (click)="selecionarPeriodo(PeriodoEnum.DoIntervalo); $event.stopPropagation()"
              [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.DoIntervalo">
              <span>do intervalo</span>
              @if (periodoSelecionado === PeriodoEnum.DoIntervalo) {
              <mat-icon>check</mat-icon>
              }
            </button>

            @if (periodoSelecionado === PeriodoEnum.DoIntervalo) {
            <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
              <mat-form-field appearance="outline">
                <mat-label>De</mat-label>
                <input matInput [matDatepicker]="pickerPeriodoDe" [(ngModel)]="periodoIntervaloDe"
                  [ngModelOptions]="{ standalone: true }" (ngModelChange)="onPeriodoIntervaloChange('de', $event)"
                  (input)="onDateInput($event)" (keydown)="onDateKeydown($event)" (blur)="onDateBlur($event, 'de')"
                  placeholder="DD/MM/AAAA" inputmode="numeric" maxlength="10" [max]="periodoIntervaloAte" />
                <mat-datepicker-toggle matSuffix [for]="pickerPeriodoDe"></mat-datepicker-toggle>
                <mat-datepicker #pickerPeriodoDe></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Até</mat-label>
                <input matInput [matDatepicker]="pickerPeriodoAte" [(ngModel)]="periodoIntervaloAte"
                  [ngModelOptions]="{ standalone: true }" (ngModelChange)="onPeriodoIntervaloChange('ate', $event)"
                  (input)="onDateInput($event)" (keydown)="onDateKeydown($event)" (blur)="onDateBlur($event, 'ate')"
                  placeholder="DD/MM/AAAA" inputmode="numeric" maxlength="10" [min]="periodoIntervaloDe" />
                <mat-datepicker-toggle matSuffix [for]="pickerPeriodoAte"></mat-datepicker-toggle>
                <mat-datepicker #pickerPeriodoAte></mat-datepicker>
              </mat-form-field>

              <div class="periodo-intervalo-actions">
                <button type="button" mat-button class="btn-secondary"
                  (click)="cancelarPeriodoIntervalo(periodoMenuTrigger)">
                  Cancelar
                </button>
                <button type="button" mat-flat-button class="btn-primary" (click)="aplicarPeriodo(periodoMenuTrigger)">
                  Aplicar
                </button>
              </div>
            </div>
            }
          </div>
        </div>
      </mat-menu>

      <button #filtrosAvancadosMenuTrigger="matMenuTrigger" mat-stroked-button type="button" class="btn-filter"
        [matMenuTriggerFor]="filtroMenu" [matBadge]="qtdFiltrosAvancados" [matBadgeHidden]="qtdFiltrosAvancados === 0">
        <mat-icon>filter_list</mat-icon>
        Filtrar
      </button>

      <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
        <div class="filter-menu-content" [formGroup]="model" (click)="$event.stopPropagation()">
          <h6>Filtros Avançados</h6>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Tipo</mat-label>
            <mat-select formControlName="idTipoMovimentoFiltro">
              <mat-option [value]="_tipoMovimentoFiltroEnum.SemFiltro">Sem filtro</mat-option>
              <mat-option [value]="_tipoMovimentoFiltroEnum.Entrada">Entrada</mat-option>
              <mat-option [value]="_tipoMovimentoFiltroEnum.Saida">Saída</mat-option>
              <mat-option [value]="_tipoMovimentoFiltroEnum.Inventario">Inventário</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="filter-menu__actions">
            <button type="button" mat-button class="btn-secondary" matMenuClose
              (click)="filtrosAvancadosMenuTrigger.closeMenu()">Cancelar</button>
            <button type="button" mat-flat-button class="btn-primary" (click)="aplicarFiltros()"
              matMenuClose>Aplicar</button>
          </div>
        </div>
      </mat-menu>

      <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
        <mat-icon>cleaning_services</mat-icon>
        Limpar Filtros
      </button>

      <button mat-stroked-button type="button" class="btn-filter desktop-view" (click)="configurarColunas()">
        <mat-icon>view_column</mat-icon>
        Configurar Colunas
      </button>
    </div>
  </div>
</form>

@if (_isLoading && _dataSource.data.length === 0) {
<app-loading-box-default-list></app-loading-box-default-list>
} @else if (_dataSource.data.length === 0) {
<app-empty-list [title]="'Nenhuma movimentação encontrada'"
  [subTitle]="'Ajuste os filtros para refinar a busca'"></app-empty-list>
} @else {
<div class="table-container desktop-view">
  <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
    <ng-container matColumnDef="dataHora">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="dataHora">Data/Hora</th>
      <td mat-cell *matCellDef="let row">{{ row.datetimeMovimentacao | date: 'dd/MM/yyyy HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="operacao">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="operacao">Operação</th>
      <td mat-cell *matCellDef="let row">
        <span class="tag-operacao" [class.tag-operacao--positivo]="row.movimentado > 0"
          [class.tag-operacao--negativo]="row.movimentado < 0">{{ row.descricaoOperacao }}</span>
        @if (row.listaSeriesMovimentadas.length) {
        <button mat-icon-button class="series-info-btn" (click)="abrirSeriesMovimentadas(row); $event.stopPropagation()"
          matTooltip="Ver números de série">
          <mat-icon class="material-symbols-outlined">info</mat-icon>
        </button>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="localizacao">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="localizacao">Localização</th>
      <td mat-cell *matCellDef="let row">{{ row.localizacao || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="origem">
      <th mat-header-cell *matHeaderCellDef class="text-center w-origem" mat-sort-header="origem">Origem</th>
      <td mat-cell *matCellDef="let row" class="text-center w-origem">
        <ng-container *ngTemplateOutlet="indicadorTpl; context: { $implicit: indicadorOrigem(row) }"></ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="clienteFornecedor">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="clienteFornecedor">Cliente/Fornecedor</th>
      <td mat-cell *matCellDef="let row">{{ row.clienteFornecedor || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="unidade">
      <th mat-header-cell *matHeaderCellDef class="w-unidade" mat-sort-header="unidade">Unidade</th>
      <td mat-cell *matCellDef="let row" class="w-unidade">{{ row.unidade || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="valorUnitario">
      <th mat-header-cell *matHeaderCellDef class="text-end" mat-sort-header="valorUnitario">Valor unitário</th>
      <td mat-cell *matCellDef="let row" class="text-end">{{ row.valorUnitario | abnt:'preco' }}</td>
    </ng-container>

    <ng-container matColumnDef="custoMedio">
      <th mat-header-cell *matHeaderCellDef class="text-end" mat-sort-header="custoMedio">Custo médio</th>
      <td mat-cell *matCellDef="let row" class="text-end">{{ row.custoMedio | abnt:'preco' }}</td>
    </ng-container>

    <ng-container matColumnDef="reservado">
      <th mat-header-cell *matHeaderCellDef class="text-end" mat-sort-header="reservado">Reservado</th>
      <td mat-cell *matCellDef="let row" class="text-end">{{ row.saldoReservado | abnt:'quantidade' }}</td>
    </ng-container>

    <ng-container matColumnDef="movimentado">
      <th mat-header-cell *matHeaderCellDef class="text-end" mat-sort-header="movimentado">Movimentado</th>
      <td mat-cell *matCellDef="let row" class="text-end" [class.movimento-negativo]="row.movimentado < 0"
        [class.movimento-positivo]="row.movimentado > 0">
        {{ row.movimentado > 0 ? '+' : '' }}{{ row.movimentado | abnt:'quantidade' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="disponivel">
      <th mat-header-cell *matHeaderCellDef class="text-end" mat-sort-header="disponivel">Disponível</th>
      <td mat-cell *matCellDef="let row" class="text-end">{{ row.disponivel | abnt:'quantidade' }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="text-end w-actions">Ações</th>
      <td mat-cell *matCellDef="let row" class="text-end w-actions">
        <button mat-icon-button [matMenuTriggerFor]="menuRow" aria-label="Ações">
          <span class="material-symbols-outlined">more_horiz</span>
        </button>
        <mat-menu #menuRow="matMenu">
          <span [matTooltip]="tooltipExcluir(row)" [matTooltipDisabled]="!tooltipExcluir(row)">
            <button mat-menu-item [disabled]="!podeEditarMovimento(row)" (click)="editarMovimento(row)">
              <span class="material-symbols-outlined">edit</span>
              <span>Editar</span>
            </button>
          </span>
          <span [matTooltip]="tooltipExcluir(row)" [matTooltipDisabled]="!tooltipExcluir(row)">
            <button mat-menu-item [disabled]="!podeExcluirMovimento(row)" (click)="excluirMovimento(row)">
              <span class="material-symbols-outlined">delete</span>
              <span>Excluir</span>
            </button>
          </span>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>

<div class="mobile-view">
  @for (row of _dataSource.data; track $index) {
  <div class="card-mobile mb-3">
    <div class="card-header-mobile d-flex justify-content-between align-items-center">
      <div class="d-flex flex-column">
        <span class="text-bold">{{ row.descricaoOperacao || '-' }} - {{row.localizacao || ''}}</span>
        <small>{{ row.datetimeMovimentacao | date: 'dd/MM/yyyy - HH:mm' }}</small>
      </div>

      <button mat-icon-button [matMenuTriggerFor]="menuMobile" aria-label="Ações">
        <span class="material-symbols-outlined">more_horiz</span>
      </button>

      <mat-menu #menuMobile="matMenu">
        <span [matTooltip]="tooltipExcluir(row)" [matTooltipDisabled]="!tooltipExcluir(row)">
          <button mat-menu-item [disabled]="!podeEditarMovimento(row)" (click)="editarMovimento(row)">
            <span class="material-symbols-outlined">edit</span>
            <span>Editar</span>
          </button>
        </span>
        <span [matTooltip]="tooltipExcluir(row)" [matTooltipDisabled]="!tooltipExcluir(row)">
          <button mat-menu-item [disabled]="!podeExcluirMovimento(row)" (click)="excluirMovimento(row)">
            <span class="material-symbols-outlined">delete</span>
            <span>Excluir</span>
          </button>
        </span>
      </mat-menu>
    </div>

    <div class="card-body-mobile p-3">
      <div class="row">
        <div class="col-6 mb-2">
          <small class="d-block">Origem</small>
          <ng-container *ngTemplateOutlet="indicadorTpl; context: { $implicit: indicadorOrigem(row) }"></ng-container>
        </div>

        <div class="col-6 mb-2">
          <small class="d-block">Cliente/Fornecedor</small>
          <span>{{ row.clienteFornecedor || '-' }}</span>
        </div>

        <div class="col-6 mb-2">
          <small class="d-block">Unidade</small>
          <span>{{ row.unidade || '-' }}</span>
        </div>

        <div class="col-6 mb-2">
          <small class="d-block">Movimentado</small>
          <span [class.movimento-negativo]="row.movimentado < 0" [class.movimento-positivo]="row.movimentado > 0">
            {{ row.movimentado > 0 ? '+' : '' }}{{ row.movimentado | abnt:'quantidade' }}
          </span>
        </div>

        <div class="col-6 mb-2">
          <small class="d-block">Disponível</small>
          <span>{{ row.disponivel | abnt:'quantidade' }}</span>
        </div>

        <div class="col-6 mb-2">
          <small class="d-block">Reservado</small>
          <span>{{ row.saldoReservado | abnt:'quantidade' }}</span>
        </div>

        @if (podeVisualizarCusto) {
        <div class="col-6 mb-2">
          <small class="d-block">Custo médio</small>
          <span>{{ row.custoMedio | abnt:'preco' }}</span>
        </div>
        }
      </div>

      @if (row.listaSeriesMovimentadas.length) {
      <div class="card-footer-mobile mt-2">
        <button mat-stroked-button type="button" class="btn-secondary" (click)="abrirSeriesMovimentadas(row)">
          <mat-icon class="material-symbols-outlined">info</mat-icon>
          Ver números de série
        </button>
      </div>
      }
    </div>
  </div>
  }
</div>

<div class="col-12 text-center">
  <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
    @if (_isLoading) {
    <mat-spinner [diameter]="20"></mat-spinner>
    } @else {
    <span class="material-symbols-outlined">expand_more</span>
    Ver Mais
    }
  </button>
</div>
}

<!-- Indicador da origem: botão quando o documento tem tela (abre em nova aba), senão só a letra. -->
<ng-template #indicadorTpl let-ind>
  @if (ind.rota) {
  <button type="button" class="indicador indicador-sm indicador-link" [style.--indicador-cor]="ind.cor"
    [matTooltip]="ind.rotulo" [attr.aria-label]="ind.rotulo" (click)="abrirDocumentoOrigem(ind.rota)">
    {{ ind.sigla }}
  </button>
  } @else {
  <span class="indicador indicador-sm" [style.--indicador-cor]="ind.cor" [matTooltip]="ind.rotulo"
    [attr.aria-label]="ind.rotulo">
    {{ ind.sigla }}
  </span>
  }
</ng-template>